import React, { useEffect, useState } from "react";
import {
  API_BASE_URL,
  directToken,
  LIST_OF_AREA,
  LIST_OF_CITY,
  LIST_OF_HOSPITAL,
  Roles_DropDown,
  UPDATE_USER,
} from "../services/end_points";
import {
  Alert,
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Typography,
} from "antd";
import axios from "axios";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";

const EditUser = ({ data }) => {
  const [alert, setAlert] = useState(null);
  const [check, setCheck] = useState(false);
  const [hos, setHos] = useState(false);
  const [checkCity, setCheckCity] = useState(false);
  const [selectedArea, setSelectedArea] = useState([]);
  const [selectedHospital, setSelectedHospital] = useState([]);
  const [hosName, setHosName] = useState(false);
  const [checkHos, setCheckHos] = useState(false);
  const [hospitalOption, setHospitalOption] = useState([]);
  const [ErrorMessage, setErrorMessage] = useState(null);
  const [cityOption, setCityOption] = useState([]);
  const [editing] = useState(true);
  const [usertype, setUsertype] = useState([]);
  const userId = localStorage.getItem("userid");

  const [formdata, setFormData] = useState({
    userName: editing ? data.userName : "",
    email: editing ? data.email : "",
    password: "",
    repassword: "",
    roleId: editing ? data.roleId : "",
    hospital: editing ? data.hospital : "",
    city: editing ? data.city : "",
    area: editing ? data.area : "",
    limit: editing ? data.limit : "",
  });

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const [filterAreas, setFilterAreas] = useState([
    { label: data.areaName, value: data.area },
  ]);
  const handleNumericChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      limit: value,
    }));
  };

  const handleRoleChange = (value, option) => {
    setFormData((prevData) => ({
      ...prevData,
      roleId: value,
    }));
    const roleLabel = option.label.toLowerCase();
    setCheck(roleLabel === "front office");
    setCheckHos(roleLabel === "front office");
    setCheckCity(roleLabel === "front office");
    setHos(roleLabel === "doctor");
    setHosName(roleLabel === "hospital");
  };

  useEffect(() => {
    setFormData({
      userName: data.userName,
      email: data.email,
      password: "",
      repassword: "",
      roleId: data.roleId,
      hospital: data.hospital,
      city: data.city,
      area: data.area,
      limit: data.limit,
    });
    if (editing) {
      const userType = data.userType?.toLowerCase();
      setHos(userType === "doctor");
      setHosName(userType === "hospital");
      setCheck(userType === "front office");
      setCheckHos(userType === "front office");
      setCheckCity(userType === "front office");
    }
    fetchRoles();
    fetchAreas();
    fetchCities();
    fetchHospitals();
  }, [editing, data.userType, data]);
  const [filterHospitals, setFilterHospitals] = useState([
    { label: data.hospitalName, value: data.hospital },
  ]);
  const fetchRoles = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}${Roles_DropDown}${userId}`
      );
      if (response.data?.list) {
        setUsertype(
          response.data.list.map((source) => ({
            label: source.userType,
            value: source.id,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching roles:", error.message);
    }
  };

  const fetchAreas = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };
      const response = await axios.get(`${API_BASE_URL}${LIST_OF_AREA}`, {
        headers,
      });
      if (response.data?.list) {
        setSelectedArea(response.data.list);
      }
    } catch (error) {
      console.error("Error fetching areas:", error.message);
    }
  };

  // const fetchHospitals = async () => {
  //   try {
  //     const headers = {
  //       "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
  //     };
  //     const response = await fetch(
  //       `${API_BASE_URL}${LIST_OF_HOSPITAL}/${userId}`,
  //       { headers }
  //     );
  //     console.log("hopsitall list is ", response.data.list);
  //     if (response.data.list) {
  //       setHospitalOption(
  //         response.data.list.map((source) => ({
  //           label: source.hospitalName,
  //           value: source.id,
  //         }))
  //       );
  //       setSelectedHospital(response.data.list);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching hospitals:", error.message);
  //   }
  // };
  const fetchHospitals = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };
      const response = await fetch(
        `${API_BASE_URL}${LIST_OF_HOSPITAL}/${userId}`,
        { headers }
      );
      const data = await response.json();
      setHospitalOption(
        data.list.map((source) => ({
          label: source.hospitalName,
          value: source.id,
        }))
      );

      setSelectedHospital(data.list);
    } catch (error) {
      console.error("Error fetching Hospital Names:", error);
    }
  };
  const fetchCities = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };
      const response = await axios.get(`${API_BASE_URL}${LIST_OF_CITY}`, {
        headers,
      });
      if (response.data?.list) {
        setCityOption(
          response.data.list.map((source) => ({
            label: source.city,
            value: source.id,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching cities:", error.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formdata.password !== formdata.repassword) {
      setAlert({ type: "error", message: "Passwords do not match." });
      return;
    }

    const id = data.userid;
    const { repassword, ...dataToSend } = formdata;

    try {
      const response = await axios.put(
        `${API_BASE_URL}${UPDATE_USER}${id}`,
        dataToSend
      );
      window.location.reload();
      if (response.status === 200) {
        setFormData({
          userName: "",
          email: "",
          password: "",
          repassword: "",
          roleId: "",
          hospital: "",
          city: "",
          area: "",
          limit: "",
        });
        setAlert({ type: "success", message: "User updated successfully!" });
      }
    } catch (error) {
      console.error("Error updating user:", error.message);
      setAlert({ type: "error", message: "Failed to update user." });
    }
  };

  return (
    <>
      <Form layout="vertical">
        <div style={{ marginTop: "20px" }}>
          {ErrorMessage && (
            <div marginBottom="20px">
              <Alert
                type="error"
                style={{ backgroundColor: "#ff4d4f", color: "white" }} // Customize the style as needed
                message={ErrorMessage}
              />
            </div>
          )}
          {alert && (
            <div marginBottom="20px">
              <Alert
                type="success"
                style={{
                  backgroundColor: "#dbffb8cf",
                  color: "black",
                  width: "100%",
                  marginTop: "0.5rem",
                  marginBottom: "2rem",
                }}
                message={"User Updated!"}
              />
            </div>
          )}
        </div>
        <Row gutter={16} style={{ display: "flex", alignItems: "center" }}>
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            <Form.Item label="Name" required>
              <Input
                style={{ width: "100%", height: "40px" }}
                required
                id="Name"
                name="userName"
                value={formdata.userName}
                onChange={handleFormChange}
              />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            <Form.Item label="Email" required>
              <Input
                style={{ width: "100%", height: "40px" }}
                required
                id="Email"
                name="email"
                value={formdata.email}
                onChange={handleFormChange}
              />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            <Form.Item label="Password" required>
              <Input.Password
                style={{ height: "40px", width: "100%" }}
                required
                name="password"
                value={formdata.password}
                onChange={handleFormChange}
                size="large"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <Row
          gutter={16}
          style={{ display: "flex", alignItems: "center", marginTop: "10px" }}
        >
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            <Form.Item label="Re-Password" required>
              <Input
                style={{
                  width: "100%",
                  height: "40px",
                }}
                required
                id="re-password"
                name="repassword"
                value={formdata.repassword}
                onChange={handleFormChange}
                type="password"
              />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            <Form.Item label="Select Role" required>
              <Select
                showSearch
                style={{
                  width: "100%",
                  height: "40px",
                }}
                name="roleId"
                value={formdata.roleId || undefined}
                onChange={handleRoleChange}
                options={usertype}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            {hos && (
              <div>
                <Form.Item label="Select Hospital" required>
                  <Select
                    showSearch
                    style={{
                      // marginTop: "2px",
                      width: "100%",
                      height: "40px",
                    }}
                    name="hospital"
                    value={formdata.hospital || undefined}
                    onChange={(value) =>
                      setFormData({ ...formdata, hospital: value })
                    }
                    options={hospitalOption}
                  />
                </Form.Item>
              </div>
            )}
          </Col>
        </Row>
        <Row
          gutter={16}
          style={{ display: "flex", alignItems: "center", marginTop: "10px" }}
        >
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            {hosName && (
              <div>
                <Form.Item label="Select Hospital" required>
                  <Select
                    showSearch
                    style={{
                      width: "100%",
                      height: "40px",
                    }}
                    name="hospital"
                    value={formdata.hospital || undefined}
                    onChange={(value) =>
                      setFormData({ ...formdata, hospital: value })
                    }
                    options={hospitalOption}
                  />
                </Form.Item>
              </div>
            )}
          </Col>
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            {hosName && (
              <div>
                <Form.Item label="Limit OF Users" required>
                  <InputNumber
                    min={1}
                    max={100000}
                    style={{
                      // marginTop: "/2px",
                      width: "100%",
                      height: "40px",
                    }}
                    value={formdata.limit}
                    name="limit"
                    onChange={handleNumericChange}
                  />
                </Form.Item>
              </div>
            )}
          </Col>
        </Row>
        <Row gutter={16} style={{ display: "flex", alignItems: "center" }}>
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            {checkCity && (
              <div>
                <Form.Item label="Select City" required>
                  <Select
                    showSearch
                    style={{
                      width: "100%",
                      height: "40px",
                    }}
                    name="city"
                    value={formdata.city || undefined}
                    onChange={(value) => {
                      setFormData({ ...formdata, city: value });
                      const filteredAreaValue = selectedArea.filter(
                        (city) => city.locationId === value
                      );
                      setFilterAreas(
                        filteredAreaValue.map((source) => ({
                          label: source.area,
                          value: source.id,
                        }))
                      );
                    }}
                    options={cityOption}
                  />
                </Form.Item>
              </div>
            )}
          </Col>
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            {check && (
              <div>
                <Form.Item label="Select Area" required>
                  <Select
                    showSearch
                    style={{
                      width: "100%",
                      height: "40px",
                    }}
                    name="area"
                    value={formdata.area || undefined}
                    onChange={(value) => {
                      setFormData({ ...formdata, area: value });

                      const selectedArea2 = selectedArea.find(
                        (area) => area.id === value
                      );

                      if (selectedArea2) {
                        // Filter hospitals based on the selected area's hospitalId
                        const filteredHospitalValue = selectedHospital.filter(
                          (hospital) => hospital.id === selectedArea2.hospitalId // Use selectedArea2 here to access hospitalId
                        );
                        setFilterHospitals(
                          filteredHospitalValue.map((hospital) => ({
                            label: hospital.hospitalName,
                            value: hospital.id,
                          }))
                        );
                      }
                    }}
                    options={filterAreas}
                  />
                </Form.Item>
              </div>
            )}
          </Col>
          <Col xl={8} lg={8} md={8} sm={12} xs={24}>
            {checkHos && (
              <div>
                <Form.Item label="Select Hospital" required>
                  <Select
                    showSearch
                    style={{
                      width: "100%",
                      height: "40px",
                    }}
                    name="hospital"
                    value={formdata.hospital || undefined}
                    onChange={(value) =>
                      setFormData({ ...formdata, hospital: value })
                    }
                    options={filterHospitals}
                  />
                </Form.Item>
              </div>
            )}
          </Col>
        </Row>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: "1rem",
          }}
        >
          <Button
            type="button"
            onClick={() =>
              setFormData({
                userName: "",
                email: "",
                password: "",
                repassword: "",
                roleId: "",
                hospital: "",
                city: "",
                area: "",
              })
            }
            style={{
              color: "black",
              border: "solid #1236fa",
              marginRight: "auto",
              width: "85px",
              height: "32px",
              borderRadius: "3vw",
            }}
          >
            Reset
          </Button>
          <Button
            type="submit"
            onClick={handleSubmit}
            style={{
              color: "white",
              background: "#1236fa",
              width: "85px",
              height: "32px",
              borderRadius: "3vw",
            }}
          >
            Submit
          </Button>
        </div>
      </Form>
    </>
  );
};
export default EditUser;
